export default __webpack_public_path__ + "static/media/river-people.a618dc60.jpg";